import React from "react";
import "./notfound.css";

// Not found page component
export default class NotFound extends React.Component {
  // render
  render() {
    return (
      <div className="page-not-found text-center">
        <h4>Page not found</h4>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/pages/NotFound.js